import { getWithRedirect, postWithRedirect } from 'utils/axios'

import { TDataRunsDto, TStartDataRunJobDto } from './contract'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const DATA_RUNS_URL = `${BASE_URL}v1/internal/data-runs`

/**
 * Fetches the Glue job run overview. Omitting `customerId` returns the
 * all-customers scope; passing it scopes jobs/aggregates/order warnings/
 * workflows to that customer and includes per-job run history.
 */
export async function getDataRuns(customerId?: string) {
  const url = customerId
    ? `${DATA_RUNS_URL}?customer_id=${encodeURIComponent(customerId)}`
    : DATA_RUNS_URL

  return getWithRedirect<TDataRunsDto>(url)
}

/** Starts one Glue job with its default arguments, outside any workflow. */
export async function startDataRunJob(jobName: string) {
  return postWithRedirect<TStartDataRunJobDto>(
    `${DATA_RUNS_URL}/jobs/${encodeURIComponent(jobName)}/start`,
    {}
  )
}
